import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col, Alert } from 'react-bootstrap';
import Masonry from 'react-masonry-component';
import _, { find as _find, isEmpty as _isEmpty, forEach as _forEach } from 'lodash';

import { getNameInCurrentLanguage } from 'helpers/intl';
import { itemAttributes, injectValidator } from 'formValidation/entityValidators';
import { dispatchResizeEvent } from 'helpers/window';

import Data from 'components/Data';
import List from 'components/List';

import IntlFormInlineSelector from 'components/intlForm/IntlFormInlineSelector';
import ItemAttribute from 'components/layout/item/ItemAttribute';
import SimplePrompt from "components/layout/SimplePrompt";
import EntityPropsUpdater from "component/EntityPropsUpdater";
// import Button from 'react-bootstrap/lib/Button';
// import AttributeNew from '../../modals/AttributeNew';

class ItemAttributes extends EntityPropsUpdater {
  /* The showNew state was only used in commented out functionality
  constructor(props) {
    super(props);

    this.state = {
      showNew: false,
    };
  }

  showNew = () => {
    this.setState({ showNew: true });
  };

  closeNew = () => {
    this.setState({ showNew: false });
  };
  */

  isCategorySelected = () => {
    const { entity, entityLoaded } = this.props;

    if (entityLoaded && entity.getCategory() && entity.getCategory().getId()) {
      return true;
    }

    return false;
  };

  isVariant = attributeId => {
    const { entity } = this.props;

    const attributes = entity?.getVariants()?.getAttributes();
    if (!attributes) {
      return false;
    }

    return attributes.some(({ id }) => id === attributeId);
  };

  onChange = e => {
    const { entity, changeEntity, list } = this.props;

    const { target } = e;
    const attributeId = target.value;
    const { checked } = target;

    let newValue;
    if (checked) {
      const attribute = _find(list.data.list, ['id', attributeId]);
      const entry = {
        id: attribute.id,
        name: attribute.name,
      };

      newValue = entity.getVariants().getAttributes();
      if (_isEmpty(newValue)) {
        newValue = [];
      } else {
        newValue = newValue.slice();
      }
      newValue.push(entity.createValue('attributes', ['variants'], entry));
    } else {
      newValue = entity
        .getVariants()
        .getAttributes()
        .filter(a => {
          return a.getId() !== attributeId;
        });
    }

    const newEntity = { ...entity.updateValue('attributes', newValue, ['variants']) };

    changeEntity(newEntity);
  };

  isAttrHighlighted = attr => {
    const { highlightedAttributes } = this.props;

    return highlightedAttributes.includes(attr.id);
  };

  handleRemoveAttribute = (e, attributeId) => {
    const { entity, entityLoaded } = this.props;
    let attributes = entityLoaded && entity?.getAttributes?.();
    if (attributes) {
      attributes = _.filter(attributes, attribute => attribute?.id !== attributeId);
      this.updateEntity('attributes', attributes);
    }

  }

  renderCategoryAttributeGroups = () => {
    const { entity, appIntl, list, category, changeEntity, disabled } = this.props;

    const res = [];
    if (category && category.data && category.data.attribute_groups) {
      category.data.attribute_groups.forEach(attributeGroup => {
        res.push(
          <Col xs={12} md={6} className="padding-10" key={attributeGroup.id}>
            <div className="bg-master-lightest padding-10">
              <p className="form-group-title">
                {getNameInCurrentLanguage(attributeGroup.attribute_group.name, appIntl)}
              </p>
              <div className="form-group-attached">
                {attributeGroup.attributes &&
                  attributeGroup.attributes
                    .filter(({ attribute: { id } }) => !this.isVariant(id))
                    .map((attribute, j) => {
                      const listAttribute = _find(list.data.list, ['id', attribute.attribute.id]);

                      return listAttribute ? (
                        <div
                          className={`field-wrapper ${
                            this.isAttrHighlighted(listAttribute) ? 'field-wrapper--highlighted' : ''
                          }`}
                        >
                          <ItemAttribute
                            key={listAttribute.id}
                            index={j}
                            attribute={listAttribute}
                            entity={entity}
                            changeEntity={changeEntity}
                            disabled={disabled}
                          />
                        </div>
                      ) : null;
                    })}
              </div>
            </div>
          </Col>
        );
      });
    }

    return res;
  };

  renderUnassignedAttributes = () => {
    const {
      intl: { messages },
      entity,
      list,
      category,
      changeEntity,
      disabled,
      entityLoaded
    } = this.props;

    const res = [];
    const grouppedAttributes = [];
    _forEach(category.data && category.data.attribute_groups, attributeGroup => {
      _forEach(attributeGroup.attributes, attribute => {
        grouppedAttributes.push(attribute.attribute.id);
      });
    });

    list.data.list
      // check if an attribute is used for variants; if so, do not display the attribute here
      .filter(({ id }) => !this.isVariant(id))
      .forEach((attribute, i) => {
        // check if the attribute was not assigned to a group yet
        const found = grouppedAttributes.includes(attribute.id);
        if (!found) {
          const classNames = ['field-wrapper'];
          let isSet = false;
          if (this.isAttrHighlighted(attribute)) {
            classNames.push('field-wrapper--highlighted');
          }
          let _attributes = entityLoaded && entity?.getAttributes?.();
          if (_attributes) {
            const index = _.findIndex(_attributes, _attribute => _attribute.id === attribute.id);
            if (index !== -1) {
             isSet = true;
            }
          }

          res.push(
            <div className={classNames.join(' ')} key={attribute.id}>
              <div className='col-xs-9 col-md-9'>
                <ItemAttribute
                  index={i}
                  attribute={attribute}
                  entity={entity}
                  changeEntity={changeEntity}
                  disabled={disabled}
                />
              </div>
              <div
                className="col-xs-3 col-md-3"
                style={{ padding: '20px'}}
              >
                {isSet &&(
                  <SimplePrompt
                    onSuccess={e => {
                      this.handleRemoveAttribute(e, attribute.id);
                    }}
                  />
                )}
              </div>
            </div>
          );
        }
      });

    return (
      res.length > 0 && (
        <Col xs={12} md={6} className="bg-master-lightest padding-10">
          <div className="bg-master-lightest padding-10" style={{ height: '100%' }}>
            <p className="form-group-title">{messages.attributes}</p>
            <div className="form-group-attached">{res}</div>
          </div>
        </Col>
      )
    );
  };

  // trigger the window resize event to make the masonry align properly
  componentDidUpdate = prevProps => {
    const { intl, entity, list, changeEntity } = this.props;

    if (prevProps.list.pending && !list.pending) {
      dispatchResizeEvent();

      const newEntity = { ...entity };

      newEntity.resetValidators();
      newEntity.addValidator(injectValidator(itemAttributes(list.data.list), intl));
      changeEntity(newEntity, null, false);
    }
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      entity,
      list,
      category,
      disabled,
      allowVariantAttributes,
    } = this.props;
    // const { showNew } = this.state;
    // Prepare attributes list display
    const { data: { list: attributesList = [] } = {} } = list;
    const columnItems = attributesList
      // do not use html content for attributes
      .filter(({ type }) => ['html', 'checkbox'].includes(type) === false)
      .map(({ id, name }, i) => {
        const inputId = `itemVariantAttribute${i}`;

        return (
          <div className="checkbox check-success" key={id}>
            <input
              disabled={disabled}
              id={inputId}
              name="variants[]"
              type="checkbox"
              value={id}
              checked={this.isVariant(id)}
              onChange={this.onChange}
            />
            <label for={inputId}>
              <IntlFormInlineSelector trigger="mouseover" />
              {getNameInCurrentLanguage(name, appIntl)}
            </label>
          </div>
        );
      });
    const columnLength = Math.ceil(columnItems.length / 3); // 3 columns or 1
    const columns = columnItems.reduce((acc, item, index) => {
      const chunkIndex = Math.floor(index / columnLength);
      if (chunkIndex >= acc.length) {
        acc[chunkIndex] = [];
      }
      acc[chunkIndex].push(item);

      return acc;
    }, []);

    return (
      <div className="clearfix">
        {this.isCategorySelected() ? (
          <Row className="p-t-20">
            {allowVariantAttributes && (
              <Col xs={12}>
                {!list.pending && (
                  <React.Fragment>
                    <p>{messages.variant_attributes}</p>
                    <Row>
                      {columns.map((column, index) => (
                        <Col
                          xs={12}
                          md={3}
                          // eslint-disable-next-line react/no-array-index-key
                          key={`attributeCol${index}`}
                          mdOffset={index === 0 ? 1 : 0}
                        >
                          {column}
                        </Col>
                      ))}
                    </Row>
                  </React.Fragment>
                )}
              </Col>
            )}

            <Col xs={12}>
              <List
                noRender
                listName="categoryAttributes"
                url="/api/attributes.json"
                urlData={{}} // filters: { categories: entity.getCategory().getId() } }}
                list={list}
                resPerPage={200}
              />
              <Data dataName="category" url={`/api/categories/${entity.getCategory().getId()}.json`} data={category} />

              {!list.pending && (
                <Masonry
                  className="attributes"
                  elementType="div"
                  options={{ transitionDuration: 0 }}
                  disableImagesLoaded={false}
                  updateOnEachImageLoad={false}
                >
                  {this.renderCategoryAttributeGroups()}
                  {this.renderUnassignedAttributes()}
                </Masonry>
              )}

              {list.data.list.length === 0 && !list.pending && (
                <Alert bsStyle="info">{messages.selected_category_has_no_attributes}</Alert>
              )}
            </Col>
          </Row>
        ) : (
          <Alert bsStyle="info">{messages.select_category}</Alert>
        )}
        {/* <Button bsStyle="primary" bsSize="sm" className="btn-rounded m-t-10 m-r-10" onClick={this.showNew}><i className="fa fa-plus" /> {messages.add_attribute}</Button>
        <div id="attribute-new">
          <AttributeNew show={showNew} close={this.closeNew} />
        </div> */}
      </div>
    );
  }
}
ItemAttributes.defaultProps = {
  inModal: false,
  allowVariantAttributes: true,
  highlightedAttributes: [],
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.categoryAttributes,
    category: state.data.category,
    newAttributeFormStatus: state.formStatus.attributeNew,
  };
};

export default injectIntl(connect(mapStateToProps)(ItemAttributes));
